import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function Hero() {
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      setSelectedCategory(url);
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20retail%20concept%20with%20soft%20pastel%20pink%20and%20sage%20green%20gradient%20waves%20flowing%20across%20a%20bright%20clean%20background%2C%20subtle%20geometric%20diamond%20patterns%2C%20modern%20minimalist%20editorial%20aesthetic%2C%20gentle%20diffused%20studio%20lighting%2C%20sophisticated%20airy%20atmosphere%20with%20floating%20translucent%20shapes%2C%20no%20text%20or%20typography%2C%20serene%20high-end%20boutique%20mood&width=1920&height=900&seq=hero-main-v2&orientation=landscape"
          alt="Basetao Spreadsheet background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-20 pb-10">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-400"></span>
          <span className="text-xs font-medium text-background-50">Updated August 2026</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4">
          Basetao Spreadsheet: The Complete Spreadsheet Guide, Templates &amp; Reviews
        </h1>

        <p className="text-sm md:text-base text-background-50/85 max-w-2xl mx-auto mb-8 leading-relaxed">
          Discover everything about Basetao Spreadsheet including tutorials, templates, reviews, shipping insights, warehouse information, discounts, and expert comparisons.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-lg bg-accent-500 text-background-50 dark:text-foreground-950 font-semibold text-base hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Basetao Spreadsheet
            <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 dark:text-foreground-950 font-semibold text-base hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-shopping-cart-2-line w-5 h-5 flex items-center justify-center"></i>
          </a>
        </div>

        <div className="max-w-md mx-auto">
          <label htmlFor="category-select" className="block text-sm font-medium text-background-50/80 mb-2 text-left">
            Browse Product Categories
          </label>
          <div className="relative">
            <select
              id="category-select"
              value={selectedCategory}
              onChange={handleCategoryChange}
              className="w-full appearance-none bg-background-50/95 backdrop-blur-sm text-foreground-800 text-sm rounded-lg px-4 py-3 pr-10 border border-background-200/50 focus:outline-none focus:ring-2 focus:ring-primary-400 cursor-pointer"
            >
              <option value="">Select a category to explore...</option>
              {categories.map((cat) => (
                <option key={cat.name} value={cat.url}>
                  {cat.name}
                </option>
              ))}
            </select>
            <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-foreground-500">
              <i className="ri-arrow-down-s-line w-5 h-5 flex items-center justify-center"></i>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-5 mt-8">
          {[
            { icon: 'ri-checkbox-circle-line', text: 'Complete Guides' },
            { icon: 'ri-refresh-line', text: 'Updated Information' },
            { icon: 'ri-file-text-line', text: 'Spreadsheet Resources' },
            { icon: 'ri-shield-check-line', text: 'Security Focused' },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-1.5 text-background-50/80 text-xs md:text-sm">
              <i className={`${item.icon} w-4 h-4 flex items-center justify-center`}></i>
              <span className="whitespace-nowrap">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}